import React from "react";
import { useTranslation } from "react-i18next";
import { Page } from "shared/ui";
import TaskCalendar from "./TaskCalendar";

const TaskHubStandaloneCalendar = () => {
  const { t } = useTranslation();

  return (
    <Page title={t("taskHub.schedule.taskHubSchedule") || "Task Hub Schedule"}>
      <TaskCalendar mode="standalone-alarms" />
    </Page>
  );
};

export { TaskHubStandaloneCalendar };
